<template>
  <v-app light>
    <Loading />
    <v-toolbar fixed class="menu_toolbar white">
      <template v-if="!isMobile">
        <v-toolbar-items class="menu_desktop ma-0">
          <div class="menu_brand text-xs-center">
            <router-link :to="{ name: 'ImoveisRoot' }">
              <img src="static/logo_menor.png" width="131" height="54" class="menu_brand_logo">
            </router-link>
          </div>
          <router-link :to="{ name: 'ImoveisRoot' }">
            <v-btn flat :ripple="false" class="menu_first_btn">
              <v-icon>home</v-icon> Imóveis
            </v-btn>
          </router-link>
          <router-link :to="{ name: 'UsuariosLista' }" v-if="$hasGeneralAccess('administracao_usuarios')" exact>
            <v-btn flat :ripple="false">
              <v-icon>people</v-icon> Usuários
            </v-btn>
          </router-link>
          <router-link :to="{ name: 'RolesLista' }" v-if="$hasGeneralAccess('administracao_niveis_acesso')" exact>
            <v-btn flat :ripple="false">
              <v-icon>security</v-icon> Níveis de acesso
            </v-btn>
          </router-link>
          <router-link :to="{ name: 'RelatoriosHistoricoData' }" v-if="$hasGeneralAccess('visualizar_relatorios')">
            <v-btn flat :ripple="false">
              <v-icon>insert_chart</v-icon> Relatórios
            </v-btn>
          </router-link>
          <router-link :to="{ name: 'UsuariosConfiguracoes' }" exact>
            <v-btn flat :ripple="false">
              <v-icon>settings</v-icon> Configurações
            </v-btn>
          </router-link>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items class="menu_desktop">
          <div class="user">
            <img :src="$auth.user().avatar" class="avatar">
            <div>
              <p><strong>{{ $auth.user().name }}</strong></p>
              <p class="caption" v-if="$auth.user().cargo">{{ $auth.user().cargo }}</p>
            </div>
          </div>
          <router-link :to="{ name: 'Logout' }" exact>
            <v-btn flat :ripple="false">
              <v-icon>exit_to_app</v-icon> Sair
            </v-btn>
          </router-link>
        </v-toolbar-items>
      </template>

      <template v-else>
        <v-btn icon @click.stop="toggleLeftNav">
          <v-icon>tune</v-icon>
        </v-btn>
        <div class="mobile-brand">
          <router-link :to="{ name: 'ImoveisRoot' }">
            <img src="static/logo_menor.png" width="102" height="42">
          </router-link>
        </div>
        <v-spacer></v-spacer>
        <v-menu bottom left offset-y>
          <v-btn icon slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense class="mobile-header-menu">
            <v-list-tile class="mobile-user" :ripple="false">
              <v-list-tile-avatar>
                <img :src="$auth.user().avatar" class="avatar">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ $auth.user().name }}</v-list-tile-title>
                <v-list-tile-sub-title v-if="$auth.user().cargo">{{ $auth.user().cargo }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>

            <v-list-tile :to="{ name: 'ImoveisRoot' }" exact>
              <v-list-tile-action><v-icon>home</v-icon></v-list-tile-action>
              <v-list-tile-title>Imóveis</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :to="{ name: 'UsuariosLista' }" v-if="$hasGeneralAccess('administracao_usuarios')" exact>
              <v-list-tile-action><v-icon>people</v-icon></v-list-tile-action>
              <v-list-tile-title>Usuários</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :to="{ name: 'RolesLista' }" v-if="$hasGeneralAccess('administracao_niveis_acesso')" exact>
              <v-list-tile-action><v-icon>security</v-icon></v-list-tile-action>
              <v-list-tile-title>Níveis de acesso</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :to="{ name: 'RelatoriosHistoricoData' }" v-if="$hasGeneralAccess('visualizar_relatorios')" class="mobile-hide-relatorios">
              <v-list-tile-action><v-icon>insert_chart</v-icon></v-list-tile-action>
              <v-list-tile-title>Relatórios</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :to="{ name: 'UsuariosConfiguracoes' }" exact>
              <v-list-tile-action><v-icon>settings</v-icon></v-list-tile-action>
              <v-list-tile-title>Configurações</v-list-tile-title>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile :to="{ name: 'Logout' }" exact>
              <v-list-tile-action><v-icon>exit_to_app</v-icon></v-list-tile-action>
              <v-list-tile-title>Sair</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
    </v-toolbar>
    <TemplateLeftNav
      :mobile="isMobile"
      :drawer="leftNavOpen"
      @update:drawer="onLeftNavUpdate"
    />
    <transition mode="out-in">
      <main>
        <router-view></router-view>
      </main>
    </transition>
    <Snackbar v-for="(item, i) in snackbar" :key="i"></Snackbar>
  </v-app>
</template>

<script>
  import Loading from './components/Utils/Loading'
  import TemplateLeftNav from './components/Template/TemplateLeftNav'
  import Snackbar from './components/Utils/Snackbar'

  export default {
    components: {
      Loading,
      TemplateLeftNav,
      Snackbar
    },
    beforeCreate () {
      this.$store.dispatch('constants/loadConstants')
      this.$store.dispatch('imoveis/loadListaFiltros')
      if (this.$auth.check()) {
        this.$auth.fetch()
      }
    },
    data () {
      return {
        transitionName: '',
        isMobile: false,
        leftNavOpen: false
      }
    },
    computed: {
      snackbar () {
        return this.$store.getters['utils/snackbar']
      }
    },
    mounted () {
      this.updateViewport()
      window.addEventListener('resize', this.updateViewport)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.updateViewport)
    },
    watch: {
      '$route' (to, from) {
        if (this.isMobile && this.isRelatoriosRoute(to.name)) {
          this.$router.replace({ name: 'ImoveisRoot' })
          return
        }

        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transitionName = toDepth < fromDepth ? 'fade-transition' : 'slide-x-transition'

        if (this.isMobile) {
          this.leftNavOpen = false
        }

        this.$store.dispatch('utils/hideLoading')
        this.$store.dispatch('utils/emptySnackbar')
      }
    },
    methods: {
      isRelatoriosRoute (routeName) {
        return typeof routeName === 'string' && routeName.indexOf('Relatorios') === 0
      },
      enforceMobileRouteRestrictions () {
        if (this.isMobile && this.isRelatoriosRoute(this.$route.name)) {
          this.$router.replace({ name: 'ImoveisRoot' })
        }
      },
      updateViewport () {
        const mobile = window.innerWidth < 960

        if (mobile !== this.isMobile) {
          this.isMobile = mobile
          this.leftNavOpen = false
        } else if (!mobile) {
          this.leftNavOpen = false
        }

        this.enforceMobileRouteRestrictions()
      },
      toggleLeftNav () {
        this.leftNavOpen = !this.leftNavOpen
      },
      onLeftNavUpdate (value) {
        this.leftNavOpen = !!value
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'

  main, .left_nav { padding-top: 78px; }
  
  .menu_toolbar { z-index: 99; }
  .menu_toolbar, .menu_toolbar .toolbar__content { height: 78px; }
  
  .menu_desktop { padding-top: 15px; }
  .menu_desktop * { color: #7D7D7D !important; }
  .menu_desktop button { font-weight: 400; text-transform: none; }
  .menu_desktop button i { margin-right: 5px; }
  .menu_desktop .router-link-active button * { color: #FF7715 !important; }
  .menu_brand { width: 300px; margin-top: -2px; }
  .menu_first_btn { margin-left: 25px; }
  
  .user { margin-top: 2px; margin-right: 16px; }
  .user .avatar { width: 44px; height: 44px; float: left; margin-right: 10px; }
  .user div { float: left; margin-top: 2px; }
  .user p { clear: left; width: 100%; margin-bottom: 0; }

  .mobile-brand a { display: inline-block; line-height: 0; }
  .mobile-header-menu { min-width: 220px; }
  .mobile-header-menu .list__tile__title { font-size: 14px; }
  .mobile-user { min-height: 64px; }

  @media (max-width: 959px) {
    .mobile-header-menu .mobile-hide-relatorios {
      display: none !important;
    }
  }

  @media (min-width: 960px) and (max-width: 1400px) {
    .menu_brand { width: 210px; }
    .menu_brand_logo { width: 108px; height: 44px; }
    .menu_first_btn { margin-left: 8px; }

    .menu_desktop { padding-top: 13px; }
    .menu_desktop .btn {
      min-width: 0;
      padding: 0 10px;
      margin: 0;
    }
    .menu_desktop .btn__content {
      font-size: 13px;
      white-space: nowrap;
    }
    .menu_desktop button i { margin-right: 4px; font-size: 20px; }

    .user { margin-right: 10px; }
    .user .avatar { width: 36px; height: 36px; margin-right: 8px; }
    .user div { margin-top: 0; }
    .user .caption { display: none; }
  }

  @media (max-width: 959px) {
    main, .left_nav { padding-top: 64px; }
    .menu_toolbar, .menu_toolbar .toolbar__content { height: 64px; }
  }
</style>



// WEBPACK FOOTER //
// App.vue?eacf4cba